import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { PostTradeService } from '../../post-trade.service';
import { ptUtilityApps } from '../../../lib/utility-apps';
import { UtilityAppsService } from '../../../shared-components/utility-apps/utility-apps.service';

import { RbGridComponent } from '../../../shared-components/rb-grid/rb-grid.component';
import { AccountReviewDetailComponent } from '../account-review-detail/account-review-detail.component';
import { BreadcrumbComponent } from '../../../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-account-review',
  templateUrl: './account-review.component.html',
  styleUrls: ['./account-review.component.scss'],
  imports: [RbGridComponent, AccountReviewDetailComponent, BreadcrumbComponent],
})
export class AccountReviewComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private activatedRoute = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);
  private route = inject(Router);
  private uas = inject(UtilityAppsService);

  rights = [];
  unsubscribe: Subject<any> = new Subject();
  accountId = '';
  gridConfig = {
    title: 'Account Monitor',
    gridName: 'AccountReviewGrid',
    showGridFilters: true,
    showFilterManager: true,
    manualSearch: true,
    searchButtonText: 'Update Search',
    showBulkActions: true,
    downloadGridButton: true,
    gridActionColumn: true,
    selectActionText: 'Select Account',
    previewActionText: 'View Account',
    showActionId: true,
    rowSelector: 'AccountID_Rev',
    gridType: 'account',
    detailViewRoute: '/account-review/',
    showGridColumnFilters: true,
    getSetup: this.getGridSetup,
    getData: this.getGridData,
    storeGridNav: true,
    defaultPageSize: 100,
  };
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade/AR',
    },
    {
      label: 'Account Monitor',
      link: 'account-review',
    },
  ];

  ngOnInit(): void {
    this.uas.appsList.set(ptUtilityApps);
    this.rights = this.ss.get('rights');
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.id) {
          this.accountId = params.id;
          this.crumbConfig.push({
            label: 'Account Detail',
            link: `account-review/${this.accountId}`,
          });
        } else {
          this.accountId = '';
        }
      });

    if (this.rights.includes('PostTradeReadOnly')) {
      this.gridConfig.showBulkActions = false;
    }
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getGridSetup() {
    const ssFilters = this.ss.get('AccountReviewGridFilters');
    const defaultview = {
      filter: [],
      sort: [],
    };

    if (!ssFilters) {
      defaultview.filter.push({
        ProcessedDate: {
          selected: ['30 days'],
        },
      });
    }

    const getHeaders = this.ptSvc.getAccountGridSetup();

    return forkJoin([getHeaders]).pipe(
      map(([data1]) => ({ ...data1, defaultview }))
    );
  }

  getGridData(reqData) {
    return this.ptSvc.getAccountGridData(reqData);
  }
}
